import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Slot } from '@pages/Schedule/components/Slot';
import { IWeekSlotProps } from '@pages/Schedule/components/Week/types';
import { formatTimeTo12Hour } from '@pages/Schedule/utils/getBlackoutsLocationForDate';
import { useScheduleContext } from '@pages/Schedule/context/useScheduleContext';
import { Routes } from '../../../../router';

export const WeekSlot = ({
  date,
  appointmentsAmount,
  eventTypes,
  blackoutsInfo,
  blackoutLocation,
}: IWeekSlotProps) => {
  const schedule = useScheduleContext();

  const navigate = useNavigate();

  const onClick = () => {
    schedule.setDate(date);

    navigate(Routes.Day);
  };

  const slotDetails =
    !!appointmentsAmount &&
    `${appointmentsAmount}${'\u00A0'}appointment${appointmentsAmount > 1 ? 's' : ''}`;

  const timeStrings = blackoutsInfo?.map(
    (slot) => `${formatTimeTo12Hour(slot.from_time)}-${formatTimeTo12Hour(slot.to_time)}`,
  );

  const blackoutsDetails = `${timeStrings} Sub-I coverage`;

  const formatTimeRange = (blackoutLocationTime: {
    from: string;
    from_time: string;
    to: string;
    to_time: string;
  }) => {
    const title = 'Location closed  - on-call coverage only';

    return `${title} ${blackoutLocationTime.from} ${blackoutLocationTime.from_time} - ${blackoutLocationTime.to} ${blackoutLocationTime.to_time}`;
  };

  return (
    <div className={`schedule-cell table-cell ${blackoutLocation ? 'blackout-location' : ''}`}>
      {!!appointmentsAmount && (
        <Slot variant="info" details={slotDetails} eventTypes={eventTypes} handleClick={onClick} />
      )}
      {blackoutsInfo && blackoutsInfo?.length > 0 && (
        <Slot
          variant="blackout"
          details={blackoutsDetails}
          eventTypes={eventTypes}
          handleClick={onClick}
        />
      )}
      {!!blackoutLocation && (
        <Slot
          variant="blackout-location"
          blackoutLocation={blackoutLocation}
          details={formatTimeRange(blackoutLocation)}
          eventTypes={eventTypes}
          handleClick={onClick}
        />
      )}
    </div>
  );
};
